export const justiceNames = [
    'Chief Justice Bauman',
    'Mr. Justice Abrioux',
    'Madam Justice Bennett',
    'Mr. Justice Butler',
    'Madam Justice DeWitt-Van Oosten',
    'Madam Justice Dickson',
    'Madam Justice Fenlon',
    'Madam Justice Fisher',
    'Mr. Justice Fitch',
    'Mr. Justice Frankel',
    'Mr. Justice Goepel',
    'Mr. Justice Grauer',
    'Justice Griffin',
    'Mr. Justice Groberman',
    'Mr. Justice Harris',
    'Justice Horsman',
    'Mr. Justice Hunter',
    'Madam Justice MacKenzie',
    'Mr. Justice Marchand',
    'Madam Justice Newbury',
    'Madam Justice Saunders',
    'Justice Skolrood',
    'Madam Justice Stromberg-Stein',
    'Mr. Justice Voith',
    'Mr. Justice Wilcock',
    'Other'
];